export const iconFontAwesomeHouseholdJarWheat = (
	<i className="fa-solid fa-jar-wheat"></i>
);
